import { createContext } from 'react';

const feedbackContext = createContext();

export default feedbackContext;